export default __webpack_public_path__ + "static/media/annual-package-info.7250c079.svg";